import styled from 'styled-components'

export const CharityCard = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-400);
  padding: var(--space-400);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-brand);
  background-color: var(--bg-secondary);
`

export const CharityLogo = styled.img`
  width: 64px;
  height: 64px;
  object-fit: contain;
  border-radius: var(--radius-brand);
`

export const CharityContent = styled.div`
  flex: 1;
`

export const CharityName = styled.div`
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-400);
`

export const PercentageSection = styled.div`
  margin-top: var(--space-600);
  padding: var(--space-500);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-brand);
  background-color: var(--bg-primary);
`

export const PercentageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--space-400);
`

export const PercentageLabel = styled.div`
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-400);
  color: var(--text-primary);
`

export const PercentageInputGroup = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-200);
`

export const PercentageInput = styled.input`
  width: 60px;
  padding: var(--space-200) var(--space-300);
  font-size: var(--font-size-400);
  font-weight: var(--font-weight-semibold);
  border: 2px solid var(--border-primary);
  border-radius: var(--radius-brand);
  background-color: var(--bg-primary);
  color: var(--text-brand);
  text-align: center;
  transition: border-color 0.2s ease-out;

  &:focus {
    outline: none;
    border-color: var(--border-brand);
  }

  /* Remove spinner arrows */
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type='number'] {
    -moz-appearance: textfield;
  }
`

export const PercentageUnit = styled.span`
  font-size: var(--font-size-400);
  font-weight: var(--font-weight-semibold);
`
